import * as actionTypes from '../actions/action-types';
import { updateObject } from '../utility';

const initialState = {
	intro: '',
	position: '',
	highlight: '',
	url: '',
	enable_interaction: { val: '0' },
	step: 0,
	element: null,
	isNewStep: false,
	selector: null,
	is_in_mobile_menu: '0',
	skip_on_big_screen: '0',
	skip_on_mobile: '0',
	alt_mobile_selector: null,
};

const setStepProp = (initState, propName, propVal) => updateObject(initState, { [propName]: propVal });

const setStepData = (initState, data) => {
	const newState = {};
	Object.keys(initState).forEach((key) => {
		newState[key] = data[key];
	});
	return newState;
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_INTRO_STEP_PROP: return setStepProp(state, action.propName, action.propVal);
		case actionTypes.SET_INTRO_STEP_DATA: return setStepData(state, action.data);
		default: return state;
	}
};

export default reducer;
